// extracted by mini-css-extract-plugin
export default {"HowToStart_Container":"HowToStart_HowToStart_Container__fv6vQ","HowToStart_Container__Links":"HowToStart_HowToStart_Container__Links__TGoX-","Header":"HowToStart_Header__41Kk1"};